'use client'

import { Icon } from '@components/primitives/Icon'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { useState } from 'react'

export const ExpandableCriteriaList = ({
  criteria,
  icon,
  iconClassName,
  initialDisplayCount = 3,
}: {
  criteria: {
    assertiveSummary: string | null
    criterion: string
    id: number
  }[]
  icon: IconDefinition
  iconClassName: string
  initialDisplayCount?: number
}) => {
  const [expanded, setExpanded] = useState(false)
  const displayCriteria = expanded
    ? criteria
    : criteria.slice(0, initialDisplayCount)
  const hasMore = criteria.length > initialDisplayCount

  const expandList = () => {
    setExpanded(!expanded)
    trackEvent(TrackingEvents.TRIAL_LISTING_ELIGIBILITY_CRITERIA_EXPANDED)
  }

  return (
    <>
      {displayCriteria.map((eligibilityCriterion) => (
        <div
          className='flex items-center gap-4'
          key={`criteria-${eligibilityCriterion.id}`}
        >
          <Icon className={iconClassName} icon={icon} size='lg' />
          <span className='line-clamp-4 md:line-clamp-2'>
            {eligibilityCriterion.assertiveSummary ??
              eligibilityCriterion.criterion}
          </span>
        </div>
      ))}

      {hasMore && !expanded && (
        <div
          className='flex cursor-pointer items-center gap-2 pt-2 text-base text-primary500'
          onClick={expandList}
        >
          {`See ${criteria.length - initialDisplayCount} more`}{' '}
          <Icon icon={faChevronDown} />
        </div>
      )}
    </>
  )
}
